import React, { useMemo } from 'react';
import { Card, CardBody } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import TableContainer from '../../../Components/Common/TableContainer';
import { formatCurrency, formatUtcDate } from '../../../helpers/format';
import { getTypeTranslation } from '../action';
import EmptyList from '../../../Components/Common/EmptyList';

const WalletLedger = ({
  t,
  transactions,
  isLoading,
  meta,
  page,
  setPage,
}) => {
  const getTranslationType = (type) => {
    return getTypeTranslation(t, type);
  };

  const columns = useMemo(
    () => [
      {
        Header: t('wallet-overview.ledger.table.date'),
        accessor: 'date',
        filterable: false,
        Cell: (props) => formatUtcDate(props.row.original.created_at),
      },
      {
        Header: t('wallet-overview.ledger.table.type'),
        accessor: 'type',
        filterable: false,
        Cell: (props) => {
          const translation = getTranslationType(props.row.original.type);
          return (
            <React.Fragment>
              <span className={`badge rounded-pill ${translation.color}`}>
                {translation.label}
              </span>
            </React.Fragment>
          );
        },
      },
      {
        Header: t('wallet-overview.ledger.table.operation-id'),
        accessor: 'id',
        filterable: false,
        Cell: (props) => props.row.original.id || '-',
      },
      {
        Header: t('wallet-overview.ledger.table.value'),
        accessor: 'amount',
        filterable: false,
        Cell: (props) => formatCurrency(props.row.original.amount),
      },
    ],
    [t]
  );

  return (
    <Card>
      <CardBody className="pt-0">
        {!transactions?.length ? (
          <div className="mt-3">
            <EmptyList
              heading={t('search-empty-heading')}
              body={t('wallet-overview.ledger.empty-body')}
            />
          </div>
        ) : (
          <TableContainer
            isLoading={isLoading}
            columns={columns}
            data={transactions || []}
            activePage={page}
            pageSize={meta?.take || 10}
            totalPages={meta?.pages || 0}
            count={meta?.total || 0}
            setPage={setPage}
            className="custom-header-css"
            divClass="table-responsive table-card mb-0"
            tableClass="align-middle table-nowrap"
            theadClass="table-light"
          />
        )}
      </CardBody>
    </Card>
  );
};

export default withTranslation()(WalletLedger);
